const timeZones = [
  { key: 'asia_manila', title: 'Asia/Manila', value: 'Asia/Manila' },
  { key: 'australia_adelaide', title: 'Australia/Adelaide', value: 'Australia/Adelaide' },
  { key: 'australia_brisbane', title: 'Australia/Brisbane', value: 'Australia/Brisbane' },
  { key: 'australia_darwin', title: 'Australia/Darwin', value: 'Australia/Darwin' },
  { key: 'australia_hobart', title: 'Australia/Hobart', value: 'Australia/Hobart' },
  { key: 'australia_melbourne', title: 'Australia/Melbourne', value: 'Australia/Melbourne' },
  { key: 'australia_perth', title: 'Australia/Perth', value: 'Australia/Perth' },
  { key: 'australia_sydney', title: 'Australia/Sydney', value: 'Australia/Sydney' },
  { key: 'pacific_auckland', title: 'Pacific/Auckland', value: 'Pacific/Auckland' },
]

export default timeZones
